import clsx from 'clsx';
import { ScrollingContainer } from 'components/CruiseSearchWidget/types';
import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { NumberOfGuests } from 'components/NumberOfGuests/NumberOfGuests';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { useCallback, useMemo } from 'react';
import { styles } from './NumberOfGuestsModal.css';
import { NUMBER_OF_GUESTS_ANCHOR_GAP, NUMBER_OF_GUESTS_PINNED_ANCHOR_GAP } from './constants';

interface NumberOfGuestsModalProps {
	filterDropdownElement?: HTMLElement | null;
	isPinned?: boolean;
	scrollingContainer?: ScrollingContainer;
}

export const NumberOfGuestsModal: React.FC<NumberOfGuestsModalProps> = ({ isPinned, filterDropdownElement, scrollingContainer }) => {
	const { setActiveFilter } = useFiltersContext();
	const { setShowFiltersModal, numberOfGuestsSelection, setNumberOfGuestsSelection } = useFiltersModalContext();
	const { isMobile, isTabletPortrait } = useBreakpoint();

	const isCenteredModal = useMemo(() => {
		return isMobile || (isTabletPortrait && isPinned);
	}, [isMobile, isTabletPortrait, isPinned]);

	const anchorGap: number = useMemo(() => {
		if ((isMobile || isTabletPortrait) && isPinned) {
			return NUMBER_OF_GUESTS_PINNED_ANCHOR_GAP;
		}

		return NUMBER_OF_GUESTS_ANCHOR_GAP;
	}, [isMobile, isTabletPortrait, isPinned]);

	const onCloseClickHandler = useCallback(() => {
		setShowFiltersModal(false);
		setActiveFilter(null);
	}, [setShowFiltersModal, setActiveFilter]);

	return (
		<NumberOfGuests
			testId="number-of-guests-modal"
			useBackdrop={true}
			anchorElement={filterDropdownElement ?? undefined}
			selection={numberOfGuestsSelection}
			onChange={setNumberOfGuestsSelection}
			onCloseClick={onCloseClickHandler}
			onBackdropClick={onCloseClickHandler}
			anchorGap={anchorGap}
			rootClass={isCenteredModal ? clsx(styles.modal, { [styles.pinned]: isPinned }) : ''}
			disableHorizontalPositioning={isCenteredModal}
			scrollingContainer={scrollingContainer}
			disableScrolling={false}
		/>
	);
};
